import React from "react";
import classes from "./TabLabel.module.scss";

const TabLabel = ({ label, count }) => (
  <span className={classes.TabLabel}>
    {label}
    <span className={classes.TabBadge}>{count}</span>
  </span>
);

export default TabLabel;
